<template>
  <v-app>
    <v-container>
      <v-row class="justify-center">
        <v-col class="col-12 col-md-12">
          <h2 class="text-center text-md-left primary--text d-flex align-center">
            <v-icon class="primary--text mr-2" size="32">monetization_on</v-icon>{{$t('psiFinancial.title')}}
          </h2>
        </v-col>
      </v-row>
      <hr class="primary--lightGray mt-3" />
      <v-col class="col-12">
        <v-row>
          <p class="primary--lightGray schedule-text mt-3">
            {{$t('psiFinancial.subtitle')}}
          </p>
        </v-row>
      </v-col>

      <div v-if="!redoForm" style="position: relative">
        <div class="container-filter">
          <div align="center" style="width: 100%" justify="end">
            <div class="footer-filter">
              <div class="card-container-filter">
                <div class="card-filter" style="position: relative">
                  <img
                    class="filter-position"
                    v-if="filterFocused"
                    :src="require('../../assets/filter-focused.svg')"
                  />
                  <img class="filter-position" v-else :src="require('../../assets/filter.svg')" />
                  <v-text-field
                    hide-details
                    solo
                    v-model="dataSearch.name"
                    label="Busque pelo nome do paciente"
                    required
                    @focus="() => (filterFocused = true)"
                    @blur="() => (filterFocused = false)"
                    prepend-inner-icon="filt"
                    background-color="#fff"
                  ></v-text-field>
                </div>
                <div class="card-filter">
                  <DatePicker
                    label="Data de início"
                    :isFlat="false"
                    background="#fff"
                    :isRequired="false"
                    @date="saveDate($event, 'beginningDate')"
                  />
                </div>
                <div class="card-filter">
                  <DatePicker
                    label="Data de fim"
                    :isFlat="false"
                    background="#fff"
                    :isRequired="false"
                    @date="saveDate($event, 'finishDate')"
                  />
                </div>
              </div>
              <div>
                <v-btn
                  color="primary"
                  class="lato-black white--text text-transform-none br-10 ml-md-5 mt-md-0"
                  height="40"
                  width="140"
                  @click="clearForm"
                >
                  Limpar filtro
                </v-btn>
                <v-btn
                  color="secondary"
                  class="lato-black white--text text-transform-none br-10 ml-1 ml-md-5"
                  height="40"
                  width="140"
                  @click="getAllAppointments"
                >
                  Filtrar
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center" v-if="isLoading">
        <p>Carregando...</p>
        <v-progress-circular indeterminate color="primary" class="mb-0"></v-progress-circular>
      </div>

      <template v-if="!isLoading && !placeholder">
        <v-row v-if="!isLoading && !placeholder" class="table-container">
          <v-simple-table :search="search" :custom-filter="filterTable">
            <template v-slot:default>
              <thead>
                <tr>
                  <th v-for="dessert in headers" v-bind:key="dessert.value" class="tc-header">
                    {{ dessert.text }}
                  </th>
                </tr>
              </thead>
              <tbody class="tc-body">
                <tr
                  v-for="appointment in appointments"
                  v-on:click="$router.push(`/psicologo/detalhe-consulta/${appointment.id}`)"
                  :key="appointment.id"
                >
                  <td>{{ appointment.patient_name }}</td>
                  <td>{{ appointment.date | formatDate }}</td>
                  <td>{{ appointment.pt_value }}</td>
                  <td>{{ appointment.stripe_payment_value }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-row>
      </template>

      <div style="margin-top: 120px">
        <v-row v-if="!placeholder" class="justify-center">
          <v-col class="col-12 col-md-4">
            <v-row>
              <v-col class="col-12">
                <div class="d-flex yellow flex-row align-center justify-space-between pa-3 title">
                  <p class="ma-0 secondary--text">
                    <v-icon class="secondary--text mr-2">monetization_on</v-icon>
                    Total do Período
                  </p>
                  <p class="ma-0 secondary--text d-flex align-center">
                    {{ '€ ' + totalValue.toString() }}
                  </p>
                </div>
                <div class="py-3 px-4">
                  <p class="ma-0 gray--text text-center obs-text mt-2">
                    Os valores serão transferidos para sua conta bancária em um prazo máximo de 7
                    dias após o recebimento.
                  </p>
                  <!-- <p class="ma-0 gray--text text-center obs-text mt-2">
                  Os valores exibidos já refletem a dedução da taxa do Ondivan.
                </p> -->
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col class="col-12 col-md-6">
            <div class="no-schedule pa-3" v-if="placeholder">
              <v-icon x-large color="gray" style="font-size: 80px; padding-bottom: 10px"
                >sentiment_very_dissatisfied</v-icon
              >
              <p class="subtitle-1" style="color: #6f6f6f; font-weight: bold">
                Não encontramos nenhum dado.
              </p>
            </div>
          </v-col>
        </v-row>
      </div>

      <div class="text-center" v-if="!isLoading && !placeholder">
        <v-pagination v-model="pageSearch" :length="lengthPage"></v-pagination>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import DatePicker from '@/components/DatePicker';
import Icon from '@/components/Icon';
import generalService from '../../services/general';

export default {
  data() {
    return {
      appointments: [],
      pageSearch: 1,
      lengthPage: 1,
      isLoading: false,
      redoForm: false,
      placeholder: false,
      totalValue: 0,
      filterFocused: false,
      headers: [
        {
          text: 'Nome',
          value: 'patient_name',
        },
        {
          text: 'Data',
          value: 'date',
        },
        {
          text: 'Valor Cobrado',
          value: 'pt_value',
        },
        {
          text: 'Valor Líquido',
          value: 'stripe_payment_value',
        },
      ],
      search: '',
      dataSearch: {
        name: '',
        initialDate: '',
        finalDate: '',
        page: 1,
      },
    };
  },
  components: {
    DatePicker,
    Icon,
  },
  mounted() {
    this.getAllAppointments();
  },
  watch: {
    pageSearch() {
      this.getAllAppointments();
    },
  },
  methods: {
    filterTable(value, search, item) {
      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
      );
    },
    async getAllAppointments() {
      this.dataSearch.page = this.pageSearch;
      try {
        this.isLoading = true;
        const { data } = await generalService.getAppointmentsFilter(this.dataSearch);
        if (data.results.length > 0) {
          this.lengthPage = Math.ceil(data.count / 12);
          const cache = [];
          for (const appointment of data.results) {
            console.log(appointment);
            cache.push({
              ...appointment,
              pt_value: `€ ${
                appointment.pt_value
                  ? appointment.pt_value - appointment.discount_coupon_value
                  : appointment.pt_value
              }`,
              stripe_payment_value: `€ ${appointment.stripe_payment_value || '0.0'}`,
            });
          }
          this.appointments = cache;
          this.totalValue = data.total_stripe_payment_value;
          this.placeholder = false;
        } else {
          this.placeholder = true;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    saveDate(value, field) {
      if (field === 'beginningDate') {
        this.dataSearch.initialDate = value;
      } else {
        this.dataSearch.finalDate = value;
      }
    },
    clearForm() {
      this.redoForm = true;
      setTimeout(() => {
        this.dataSearch.name = '';
        this.dataSearch.initialDate = '';
        this.dataSearch.finalDate = '';
        this.getAllAppointments();
        this.redoForm = false;
      }, 10);
    },
  },
};
</script>

<style lang="css" scoped>
.custom-radius {
  border-radius: 30px;
}

.custom-radius__tag {
  border-radius: 0 30px 30px 0;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
}

.obs-text {
  font-size: 0.8rem;
}

.no-schedule {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #02a55333;
  border-radius: 20px;
  border: 1px dashed #02a554;
}

.filter-position {
  width: 27px;
  z-index: 6;
  top: 14px;
  left: 10px;
  margin-right: 2px;
  position: absolute;
}
.v-data-table {
  width: 100%;
  margin: 50px 0px;
  border: 1px solid #e2e2e2;
  background: #fff;
  border-radius: 5px;
  margin-top: 120px !important;
}

.tc-header {
  font-size: 17px !important;
}
.tc-body > tr:nth-child(even) {
  background: #fff !important;
}
.tc-body > tr:nth-child(odd) {
  background: #f7f7f7 !important;
}
.tc-body tr {
  border: 0;
  cursor: pointer;
}
.tc-body tr td {
  font-size: 16px !important;
  color: #7a7a7a !important;
  border: 0px !important;
}
.tc-body tr td:last-child {
  color: #47ad63 !important;
  font-weight: 500;
}

.footer-filter {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 0px;
  justify-content: space-between;
}

.footer-filter > div:first-child {
  width: 72.2% !important;
  display: flex;
}
.footer-filter > div:last-child button:first-child {
  margin-left: 0 !important;
}
.card-container-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-filter {
  margin-left: 20px;
}
.card-container-filter .card-filter:first-child {
  width: 50%;
  margin-left: 0px;
}

.container-filter {
  width: 100%;
  margin: 10px 0px;
  position: absolute;
  top: 0px;
  right: -24px;
}

@media screen and (max-width: 1172px) {
  .table-container {
    padding: 0 0.5rem;
  }
  .tc-body tr td {
    font-size: 12px !important;
    color: #7a7a7a !important;
    border: 0px !important;
  }
  .tc-header {
    font-size: 12px !important;
  }
  .footer-filter {
    width: 100% !important;
    max-width: 670px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .card-filter {
    width: 100%;
    margin: 10px 0px !important;
  }
  .footer-filter > div:first-child {
    width: inherit !important;
    display: flex;
    flex-direction: column;
  }
  .footer-filter > div:last-child {
    margin-top: 25px;
  }
  .card-container-filter .card-filter:first-child {
    width: 100% !important;
  }
  .container-filter {
    right: 0;
    position: inherit;
  }
  .v-data-table {
    margin-top: 50px;
  }
}
</style>
